export enum ApplicationUserTypes {
  InternalUsers = 1,
  ExternalUsers = 2,
  InternalAndExternalUsers = 3
}
